import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { rerender } from "../../redux/rerender/slice";
import { useAppDispatch } from "../../redux/store";
import { cartSelector } from "../../redux/cart/selectors";
import {HandySvg} from 'handy-svg'
import styles from "./CartIcon.module.scss";
import basketIcon from "../../assets/icons/basket.svg";
import basketIconFocus from "../../assets/icons/basket-focus.svg";
import basketIconFull from "../../assets/icons/basketFullIcon.svg";
import basketIconFullFocus from "../../assets/icons/basketFullIcon-focus.svg";

import { useCurrentWidth } from "../../hooks";
import { MediaBreakPoints } from "../../resources/constants";

export const CartIcon: React.FC = () => {
  const { totalCartItems } = useSelector(cartSelector);
  const dispatch = useAppDispatch();
  const [isHovered, setIsHovered] = useState(false);
  
  const location = useLocation();
  const windowWidth = useCurrentWidth();
  const breakPoint = MediaBreakPoints.MOBILE_LARGE;

  const isCartEmpty = testCartEmpty(totalCartItems);
  const cartIcon = renderCartIcon();

  function renderCartIcon() {
    if (isHovered) {
      return isCartEmpty ? basketIconFocus : basketIconFullFocus;
    }
    
    if (windowWidth > breakPoint) {
      return isCartEmpty ? basketIcon : basketIconFull;
    } else {
      return isCartEmpty ? basketIcon : basketIconFull;
    }
  }

  function testCartEmpty(totalCartItems: { [key: string]: { [key: string]: any } }) {
    if (!totalCartItems) return true;
    
    const seats = totalCartItems.seats || {};
    const subscriptions = totalCartItems.subscriptions || {};
    
    return (
      Object.keys(seats).length === 0 &&
      Object.keys(subscriptions).length === 0
    );
  }

  const handleClick = () => {
    const currentPath = location.pathname;
    if (currentPath === "/cart") {
      dispatch(rerender());
    }
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div className={styles.icons__cart}>
      <Link 
        to="/cart" 
        onClick={handleClick} 
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        state={{ from: location.pathname }}
      >
        <img src={cartIcon} alt="Корзина" width={20} height={20}/>
        <span>Корзина</span>
      </Link>
    </div>
  );
};
